import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import {
  Button,
  ListBox,
  PageTitle,
  Section,
  Badge,
  Loading,
} from "../../components";
import { EditIcon } from "../../assets/icons";
import useSupplierService from "../../services/api/supplierService";

function SuppliersDetailsPage() {
  const { supplierId } = useParams();
  const navigate = useNavigate();
  const { getSupplierById, queryKey } = useSupplierService();

  const { data, isLoading, error } = useQuery({
    queryKey: [queryKey, { supplierId }],
    queryFn: () => getSupplierById(supplierId),
    enabled: !!supplierId,
  });

  if (isLoading) return <Loading isLoading={isLoading} variant="fullScreen" />;
  if (error) return <div>Error loading supplier details</div>;

  return (
    <div className="page supplier-details-page">
      <PageTitle text="View Supplier Details" prev="/suppliers">
        <div className="action-list-wide">
          <Link to={`/suppliers/edit/${supplierId}`}>
            <Button text="Edit Supplier Details" icon={<EditIcon />} />
          </Link>
        </div>

        <ListBox
          className="action-list"
          options={[
            {
              text: "Edit Supplier Details",
              onClick: () => navigate(`/suppliers/edit/${supplierId}`),
            },
          ]}
        />
      </PageTitle>
      <Section className="supplier-details-data">
        <div className="supplier-name-details">
          <div className="supplier-name">
            <h6>Supplier Name</h6>
            <h2>{data?.name || "NA"}</h2>
          </div>
          <div className="supplier-company">
            <h6>Company Name</h6>
            <h4>{data?.companyName || "NA"}</h4>
          </div>
        </div>

        <div className="supplier-mobile-numbers">
          <div className="mobile-number-list">
            {data?.phoneNumbers?.length > 0 ? (
              data.phoneNumbers.map((number, index) => (
                <div key={index} className="mobile-number-item">
                  <Badge text={`Phone Number ${index + 1}`} />
                  <span>{number}</span>
                </div>
              ))
            ) : (
              <p>No phone numbers available</p>
            )}
          </div>
        </div>

        {data?.bankDetails?.length > 0 && (
          <div className="supplier-bank-details-section">
            {data.bankDetails.map((account, index) => (
              <Section
                key={account?._id}
                wrapperClassName="supplier-bank-details"
              >
                <div className="supplier-bank-details-title">
                  <Badge text={`Bank Account ${index + 1}`} />
                </div>
                <div className="supplier-bank-detail acc">
                  <Badge text="Account Number" />
                  <span>{account.accountNumber}</span>
                </div>
                <div className="supplier-bank-detail bank">
                  <Badge text="Bank Name" />
                  <span>{account.bankName}</span>
                </div>
                <div className="supplier-bank-detail">
                  <Badge text="Account Name" />
                  <span>{account.accountOwnerName}</span>
                </div>
                <div className="supplier-bank-detail">
                  <Badge text="Branch" />
                  <span>{account.branch}</span>
                </div>
              </Section>
            ))}
          </div>
        )}
      </Section>
    </div>
  );
}
export default SuppliersDetailsPage;
